import React, { useState } from 'react';
import styled from 'styled-components';
import { ArrowDownBox, ArrowUpBox } from 'components/wizard/styles';
import { ChevronDownIcon, ChevronUpIcon } from 'components/v2/epd-compiler-inputs/common-icons';
import { InfoBox } from 'styles/Styles.styled';

import { ConformityStandardsInfoBody, conformityStandardsInfoFirstSentence } from './ConformityStandardsInfo';

/**
 * Simple Wizard information box for the "Standards conformance" field (#19675): the first sentence is the header,
 * the rest is shown below it while the box is expanded. It opens expanded on every mount; the state is not stored.
 */
const ConformityStandardsInfoBox: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const Text = isExpanded ? ArrowUpBox : ArrowDownBox;

  return (
    <Box>
      <Text>
        <Header>{conformityStandardsInfoFirstSentence}</Header>
        {isExpanded && <ConformityStandardsInfoBody />}
      </Text>
      {/* Chevron as in the Compiler box; the grey arrow png of the other wizard boxes is barely visible on this background. */}
      <Toggle
        type="button"
        aria-label={isExpanded ? 'Collapse' : 'Expand'}
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        {isExpanded ? <ChevronUpIcon /> : <ChevronDownIcon />}
      </Toggle>
    </Box>
  );
};

export default ConformityStandardsInfoBox;

const Box = styled(InfoBox)`
  align-items: center;
  padding: 0.5rem 0 0.5rem 1.2rem;
  margin-bottom: 0;
`;

const Header = styled.div`
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;

  & + * {
    margin-top: 0.5rem;
  }
`;

const Toggle = styled.button`
  display: flex;
  align-self: flex-start;
  flex-shrink: 0;
  margin: 2px 1rem 0 0;
  padding: 0;
  border: 0;
  background: none;
  cursor: pointer;

  & svg {
    color: rgb(156, 156, 156);
  }
`;
